import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReturnsComponent } from './returns/returns.component';
import { ContactComponent } from './contact/contact.component';
import { FaqComponent } from './faq/faq.component';
import { PrivacyComponent } from './privacy/privacy.component';


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ReturnsComponent,
    ContactComponent,
    FaqComponent,
    PrivacyComponent
  ]
})
export class StaticModule { }



// WEBPACK FOOTER //
// ./src/app/static/static.module.ts